// extracted by mini-css-extract-plugin
module.exports = {"referenceLink":"ReferenceLink_referenceLink__hcFAY","text":"ReferenceLink_text__9UMET"};